<script setup>
import { useI18n } from 'vue-i18n';
import { isImageAttachment } from '../utils/supportTicketPortal';
import { useSupportTicketFormatters } from '../composables/useSupportTicketFormatters';

defineProps({
  selectedEvents: { type: Array, default: () => [] },
});

const { t } = useI18n();
const { localizedDate } = useSupportTicketFormatters();
</script>

<template>
  <div class="grid gap-3">
    <div
      v-for="event in selectedEvents"
      :key="event.id"
      class="rounded-lais border px-4 py-3"
      :class="
        event.internal
          ? 'border-amber-200 bg-amber-50'
          : 'border-lais-border-soft bg-white'
      "
    >
      <div class="flex flex-wrap items-center justify-between gap-2">
        <p class="text-[12px] font-semibold text-lais-text">
          {{ event.author_name || t('SUPPORT_TICKETS.DETAIL.SUPPORT') }}
          <span
            v-if="event.author_role"
            class="font-normal text-lais-text-muted"
          >
            {{ event.author_role }}
          </span>
          <span
            v-if="event.internal"
            class="ml-2 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800"
          >
            {{ t('SUPPORT_TICKETS.DETAIL.INTERNAL') }}
          </span>
        </p>
        <p class="text-[11px] text-lais-text-muted">
          {{ localizedDate(event.created_at) }}
        </p>
      </div>
      <p
        class="mt-2 whitespace-pre-line text-[13px] leading-6 text-lais-text-body"
      >
        {{ event.body }}
      </p>
      <div
        v-if="event.attachments?.length"
        class="mt-3 grid gap-2 sm:grid-cols-2"
      >
        <a
          v-for="attachment in event.attachments"
          :key="attachment.id || attachment.url"
          :href="attachment.url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-2 rounded-lais border border-lais-border-soft bg-lais-bg px-3 py-2 text-[12px] font-semibold text-lais-text"
        >
          <img
            v-if="isImageAttachment(attachment)"
            :src="attachment.url"
            :alt="attachment.filename"
            class="size-8 rounded object-cover"
          />
          <span
            v-else
            class="i-lucide-file-text size-4 shrink-0"
            aria-hidden="true"
          />
          <span class="truncate">
            {{
              t('SUPPORT_TICKETS.ATTACHMENTS.DOWNLOAD', {
                name: attachment.filename,
              })
            }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>
